module.exports = __webpack_public_path__ + "img/5.268a89ea.jpg";